<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter801strangestep">CHAPTER 801 - STRANGE STEP</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter802activatingthedemonicpalace">CHAPTER 802 - ACTIVATING THE DEMONIC PALACE</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter803whowastrappedmorethanadecadeago">CHAPTER 803 - WHO WAS TRAPPED MORE THAN A DECADE AGO</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter804icansavethem">CHAPTER 804 - I CAN SAVE THEM</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter805awakening">CHAPTER 805 - AWAKENING</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter806thepassagebehindtherestriction">CHAPTER 806 - THE PASSAGE BEHIND THE RESTRICTION</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter807martialskillstoneforest">CHAPTER 807 - MARTIAL SKILL STONE FOREST</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter808windandcloudriseagain">CHAPTER 808 - WIND AND CLOUD RISE AGAIN</a>
</li>
<li class="table-of-content">
<a href="#/8_chapter809fourcrises">CHAPTER 809 - FOUR CRISES</a>
</li>
<li class="table-of-content">
<span href="#/9_chapter810canalicular" title="Link target outside of Sample">CHAPTER 810 - CANALICULAR</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter811heavenswallowingpython" title="Link target outside of Sample">CHAPTER 811 - HEAVEN SWALLOWING PYTHON</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter812ashes" title="Link target outside of Sample">CHAPTER 812 - ASHES</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter813escape" title="Link target outside of Sample">CHAPTER 813 - ESCAPE</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter814itreallyishim" title="Link target outside of Sample">CHAPTER 814 - 'IT REALLY IS HIM! '</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter815confusion" title="Link target outside of Sample">CHAPTER 815 - CONFUSION</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter816floweringhanchenshand" title="Link target outside of Sample">CHAPTER 816 - FLOWERING HAN CHEN'S HAND</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter817seal" title="Link target outside of Sample">CHAPTER 817 - SEAL</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter818goldenlotusseat" title="Link target outside of Sample">CHAPTER 818 - GOLDEN LOTUS SEAT</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter819iamevilandiburytheheartofthedevil" title="Link target outside of Sample">CHAPTER 819 - I AM EVIL, AND I BURY THE HEART OF THE DEVIL</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter820crisisattacks" title="Link target outside of Sample">CHAPTER 820 - CRISIS ATTACKS</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter821thequalificationofconditions" title="Link target outside of Sample">CHAPTER 821 - THE QUALIFICATION OF CONDITIONS</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter822roll" title="Link target outside of Sample">CHAPTER 822 - ROLL</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter823cangtaiji" title="Link target outside of Sample">CHAPTER 823 - CANG TAIJI</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter824facetofaceconfrontation" title="Link target outside of Sample">CHAPTER 824 - FACE TO FACE CONFRONTATION</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter825fourimagesofsuppressingyinandyang" title="Link target outside of Sample">CHAPTER 825 - FOUR IMAGES OF SUPPRESSING YIN AND YANG</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter826cangtaijisstrength" title="Link target outside of Sample">CHAPTER 826 - CANG TAIJI'S STRENGTH</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter827stormattack" title="Link target outside of Sample">CHAPTER 827 - STORM ATTACK</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter828cangtaijislasttrumpcard" title="Link target outside of Sample">CHAPTER 828 - CANG TAIJI'S LAST TRUMP CARD</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter829killcangtaiji" title="Link target outside of Sample">CHAPTER 829 - KILL CANG TAIJI</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter830venerableoneinthesword" title="Link target outside of Sample">CHAPTER 830 - VENERABLE ONE IN THE SWORD</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter831casanova" title="Link target outside of Sample">CHAPTER 831 - CASANOVA</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter832opencasanova" title="Link target outside of Sample">CHAPTER 832 - OPEN CASANOVA</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter833palacesilvertower" title="Link target outside of Sample">CHAPTER 833 - PALACE SILVER TOWER</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter834strangepillar" title="Link target outside of Sample">CHAPTER 834 - STRANGE PILLAR</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter835goldenpagoda" title="Link target outside of Sample">CHAPTER 835 - GOLDEN PAGODA</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter836thoughtprovoking" title="Link target outside of Sample">CHAPTER 836 - THOUGHT-PROVOKING</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter837seedofimmortalspirit" title="Link target outside of Sample">CHAPTER 837 - SEED OF IMMORTAL SPIRIT</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter838casanovaliufeixu" title="Link target outside of Sample">CHAPTER 838 - CASANOVA, LIU FEIXU</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter839likeadreamoradreamhewasstilldrunkandhadyettowakeup" title="Link target outside of Sample">CHAPTER 839 - LIKE A DREAM OR A DREAM, HE WAS STILL DRUNK AND HAD YET TO WAKE UP</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter840innermost" title="Link target outside of Sample">CHAPTER 840 - INNERMOST</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter841theonlypersonwhounderstands" title="Link target outside of Sample">CHAPTER 841 - THE ONLY PERSON WHO UNDERSTANDS</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter842dreamdisillusionmentkillingarrayactivated" title="Link target outside of Sample">CHAPTER 842 - DREAM-DISILLUSIONMENT KILLING ARRAY, ACTIVATED</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter843adreamoftheyellowriver" title="Link target outside of Sample">CHAPTER 843 - A DREAM OF THE YELLOW RIVER</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter844robbing" title="Link target outside of Sample">CHAPTER 844 - ROBBING</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter845sevenemotionsandsixdesires" title="Link target outside of Sample">CHAPTER 845 - SEVEN EMOTIONS AND SIX DESIRES</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter846theoriginoferoticpalace" title="Link target outside of Sample">CHAPTER 846 - THE ORIGIN OF EROTIC PALACE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter847mystery" title="Link target outside of Sample">CHAPTER 847 - MYSTERY</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter848heavenbeautyyufenglan" title="Link target outside of Sample">CHAPTER 848 - HEAVEN BEAUTY, YU FENGLAN</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter849likeadreamorafantasyabeautylikeajade" title="Link target outside of Sample">CHAPTER 849 - "LIKE A DREAM OR A FANTASY, A BEAUTY LIKE A JADE"</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter850asuddenchangeofheart" title="Link target outside of Sample">CHAPTER 850 - A SUDDEN CHANGE OF HEART</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter851zhonglisurname" title="Link target outside of Sample">CHAPTER 851 - ZHONG LI SURNAME</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter852ihaveacondition" title="Link target outside of Sample">CHAPTER 852 - I HAVE A CONDITION</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter853thewholeuniversewhoadvocateupsanddowns" title="Link target outside of Sample">CHAPTER 853 - THE WHOLE UNIVERSE, WHO ADVOCATE UPS AND DOWNS</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter854shockingtheworld" title="Link target outside of Sample">CHAPTER 854 - SHOCKING THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter855saintsterrace" title="Link target outside of Sample">CHAPTER 855 - SAINTS TERRACE</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter856beforethegreatwar" title="Link target outside of Sample">CHAPTER 856 - BEFORE THE GREAT WAR</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter857noitwaslonghabitat" title="Link target outside of Sample">CHAPTER 857 - NO, IT WAS LONG HABITAT!</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter858dateofthedecisivebattle" title="Link target outside of Sample">CHAPTER 858 - DATE OF THE DECISIVE BATTLE</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter859agatheringofdragonsameetingofthewindandtheclouds" title="Link target outside of Sample">CHAPTER 859 - A GATHERING OF DRAGONS, A MEETING OF THE WIND AND THE CLOUDS</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter860thefirstbattlehadbegun" title="Link target outside of Sample">CHAPTER 860 - THE FIRST BATTLE HAD BEGUN!</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter861thegreatdaowasthesimplesttheheartrefinedtheworld" title="Link target outside of Sample">CHAPTER 861 - THE GREAT DAO WAS THE SIMPLEST, THE HEART REFINED THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter862heavenspridebattleevilseed" title="Link target outside of Sample">CHAPTER 862 - HEAVEN'S PRIDE BATTLE EVIL SEED</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter863swordtechniquesandtechniques" title="Link target outside of Sample">CHAPTER 863 - SWORD TECHNIQUES AND TECHNIQUES</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter864hide" title="Link target outside of Sample">CHAPTER 864 - HIDE</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter865yeweinistruestrength" title="Link target outside of Sample">CHAPTER 865 - YE WEINI'S TRUE STRENGTH</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter866fightingoutbreak" title="Link target outside of Sample">CHAPTER 866 - FIGHTING OUTBREAK</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter867longhabitatdouble" title="Link target outside of Sample">CHAPTER 867 - LONG HABITAT DOUBLE</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter868thebattleofthepeak" title="Link target outside of Sample">CHAPTER 868 - THE BATTLE OF THE PEAK</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter869thefightingwasfierce" title="Link target outside of Sample">CHAPTER 869 - THE FIGHTING WAS FIERCE</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter870viciousleimingtian" title="Link target outside of Sample">CHAPTER 870 - VICIOUS LEI MINGTIAN</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter871whowillbethewinnerofthisfight" title="Link target outside of Sample">CHAPTER 871 - WHO WILL BE THE WINNER OF THIS FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter872heavenshakingchange" title="Link target outside of Sample">CHAPTER 872 - HEAVEN-SHAKING CHANGE</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter873hanchenwokeup" title="Link target outside of Sample">CHAPTER 873 - HAN CHEN WOKE UP</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter874defeatwithonemove" title="Link target outside of Sample">CHAPTER 874 - DEFEAT WITH ONE MOVE</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter875hisnamewashanchen" title="Link target outside of Sample">CHAPTER 875 - HIS NAME WAS HAN CHEN.</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter876shockingwars" title="Link target outside of Sample">CHAPTER 876 - SHOCKING WARS</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter877shenyu" title="Link target outside of Sample">CHAPTER 877 - SHEN YU</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter878youwillbeverydisgraced" title="Link target outside of Sample">CHAPTER 878 - YOU WILL BE VERY DISGRACED</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter879powerful" title="Link target outside of Sample">CHAPTER 879 - POWERFUL</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter880swordlord" title="Link target outside of Sample">CHAPTER 880 - SWORD LORD</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter881swordintentmanifestation" title="Link target outside of Sample">CHAPTER 881 - SWORD INTENT MANIFESTATION</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter882zhongshanwindandrainthesworddisappears" title="Link target outside of Sample">CHAPTER 882 - ZHONG SHAN WIND AND RAIN, THE SWORD DISAPPEARS</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter883theswordsaintwassorrowfulbuttheswordfingerwasstillalive" title="Link target outside of Sample">CHAPTER 883 - THE SWORD SAINT WAS SORROWFUL, BUT THE SWORD FINGER WAS STILL ALIVE …</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter884letsseewhowillseekdeath" title="Link target outside of Sample">CHAPTER 884 - 'LET'S SEE WHO WILL SEEK DEATH! '</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter885swordsoulswordsoulslash" title="Link target outside of Sample">CHAPTER 885 - SWORD SOUL, SWORD SOUL SLASH</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter886thestrugglebetweenthetianxieshadcometoanend" title="Link target outside of Sample">CHAPTER 886 - THE STRUGGLE BETWEEN THE TIAN XIE S HAD COME TO AN END.</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter887ikilledhim" title="Link target outside of Sample">CHAPTER 887 - I KILLED HIM</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter888asuddensurprise" title="Link target outside of Sample">CHAPTER 888 - A SUDDEN SURPRISE</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter889whoeverdarestostopmeiwillkill" title="Link target outside of Sample">CHAPTER 889 - WHOEVER DARES TO STOP ME, I WILL KILL!]</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter890theskymansionchasedafterhim" title="Link target outside of Sample">CHAPTER 890 - THE SKY MANSION CHASED AFTER HIM.</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter891ifyouwanttoaddtoyourcrimesyouwillhavenothingtosay" title="Link target outside of Sample">CHAPTER 891 - "IF YOU WANT TO ADD TO YOUR CRIMES, YOU WILL HAVE NOTHING TO SAY"</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter892killingtosilence" title="Link target outside of Sample">CHAPTER 892 - KILLING TO SILENCE</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter893fiercefightingpuxiuluo" title="Link target outside of Sample">CHAPTER 893 - FIERCE FIGHTING PU XIULUO</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter894youretheonewhosgoingtokillme" title="Link target outside of Sample">CHAPTER 894 - YOU'RE THE ONE WHO'S GOING TO KILL ME</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter895wisefighting" title="Link target outside of Sample">CHAPTER 895 - WISE FIGHTING</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter896imrich" title="Link target outside of Sample">CHAPTER 896 - I'M RICH</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter897astrangepicture" title="Link target outside of Sample">CHAPTER 897 - A STRANGE PICTURE</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter898itsnotsomethingthathumansdo" title="Link target outside of Sample">CHAPTER 898 - IT'S NOT SOMETHING THAT HUMANS DO</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter899superexplosion" title="Link target outside of Sample">CHAPTER 899 - SUPEREXPLOSION</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter900thewrathofpuxinghe" title="Link target outside of Sample">CHAPTER 900 - THE WRATH OF PU XINGHE</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6fe76822